import { gsap } from 'gsap';
import Headroom from 'headroom.js';
import { headerHeight } from '../helpers';

if (!window.dAgency) window.dAgency = {};

(function ($) {
  const $siteHeader = $('.site-header');
  const $header = $siteHeader.find('.header__container');
  if ($siteHeader <= 0 || $header.length <= 0)
    return false;

  $('html').css('scroll-padding-top', headerHeight() + 'px');
  $('#PageContainer').css('min-height', 'calc(100vh - ' + headerHeight() + 'px)');
  $('#CartPopup').css('top', headerHeight() + 'px');

  $(window).on('resize', function () {
    $('html').css('scroll-padding-top', headerHeight() + 'px');
    $('#PageContainer').css('min-height', 'calc(100vh - ' + headerHeight() + 'px)');
    $('#CartPopup').css('top', headerHeight() + 'px');
  });

  /* ====================== HeadrooomJS ====================== */
  const header = document.querySelector('header.site-header');
  if (header) {
    const options = {
      offset: 50,
      tolerance: {
        up: 20,
        down: 20
      },
      onPin: function () {
        if (this.elem) {
          const $announcement = $(this.elem).find('#shopify-section-announcement-bar');
          if ($announcement.length > 0) {
            if ($desktopMenu.length > 0 && $desktopMenu.hasClass('header__desktop-menu--drawer')) {
              $desktopMenu.find('.header__desktop-menu--drawer__second-level').each(function () {
                $(this).css('height', 'calc(100vh - ' + headerHeight() + 'px)');
              });
            }
          }
        }
      },
      onUnpin: function () {
        if (this.elem) {
          const $announcement = $(this.elem).find('#shopify-section-announcement-bar');
          if ($announcement.length > 0) {
            if ($desktopMenu.length > 0 && $desktopMenu.hasClass('header__desktop-menu--drawer')) {
              $desktopMenu.find('.header__desktop-menu--drawer__second-level').each(function () {
                $(this).css('height', 'calc(100vh - ' + headerHeight() + 'px)');
              });
            }
          }
        }
      }
    };

    const headroom = new Headroom(header, options);
    headroom.init();
  }

  /* ======================== Header ======================== */
  if (($header.hasClass('header__transparent') && !$('html').hasClass('.template-product')) || ($header.hasClass('header__transparent') && $('html').hasClass('.template-product') && $(window).outerWidth() < 1024)) {
    if ($(window).scrollTop() === 0) {
      $header.addClass('apply-transparency');
    } else {
      $header.removeClass('apply-transparency');
    }

    $(window).on('scroll', function () {
      if (!$header.hasClass('force-opacity')) {
        if ($(window).scrollTop() === 0) {
          $header.addClass('apply-transparency');
        } else {
          $header.removeClass('apply-transparency');
        }
      }
    });
  }

  $header.on('mouseenter', function () {
    if ($(window).outerWidth() > 1024) {
      $header.removeClass('apply-transparency');
    }
  });
  $header.on('mouseleave', function () {
    if ($(window).scrollTop() === 0 && $(window).outerWidth() > 1024 && !$header.hasClass('force-opacity')) {
      $header.addClass('apply-transparency');
    }
  });

  $header.find('.header__left__newsletter-button').on('click', function () {
    if (typeof (window.dAgency.showNewsletterPopUp) === 'function') window.dAgency.showNewsletterPopUp();
  });

  /* ======================== Mobile Menu ======================== */
  const $mobileMenu = $header.find('.header__mobile-menu');
  if ($mobileMenu.length > 0) {
    document.addEventListener('dAgency:announcement-ready', function() {
      if ($mobileMenu.hasClass('header__mobile-menu--dropdown')) {
        $mobileMenu.find('[data-link-opener]').on('click', function (e) {
          if (e.target.getAttribute('href')) return;

          const drawerAttribute = $(this).data('link-opener');
          const $drawer = $(this).parent().find('[data-level="' + drawerAttribute + '"]');
          if ($drawer.length > 0) {
            $drawer.addClass('open');
          }
        });

        $mobileMenu.find('[data-close-level]').on('click', function () {
          $(this).parent().removeClass('open');
        });
      } else if ($mobileMenu.hasClass('header__mobile-menu--drawer')) {
        const $firstLevel = $mobileMenu.find('.header__mobile-menu--drawer__first-level__title');
        $firstLevel.each(function () {
          const submenu = $(this).data('submenu');
          const $connectedSecondLevel = $mobileMenu.find('.header__mobile-menu--drawer__second-level[data-submenu="' + submenu + '"]');
          $(this).on('click', function (e) {
            if ($connectedSecondLevel.length <= 0) {
              return;
            } else {
              e.preventDefault();
            }

            $connectedSecondLevel.addClass('open');
          });
        });

        const $secondLevel = $mobileMenu.find('.header__mobile-menu--drawer__second-level');
        $secondLevel.each(function () {
          const $level = $(this);
          const $close = $(this).find('.header__mobile-menu--drawer__second-level__close');
          $close.on('click', function () {
            $level.removeClass('open');
          });

          const $titles = $(this).find('.header__mobile-menu--drawer__second-level__title');
          $titles.each(function () {
            const accordionIndex = $(this).data('accordion-index');
            const $otherThirdLevels = $level.find('.header__mobile-menu--drawer__third-level:not([data-accordion-index="' + accordionIndex + '"])');
            const $connectedThirdLevel = $level.find('.header__mobile-menu--drawer__third-level[data-accordion-index="' + accordionIndex + '"]');

            $(this).on('click', function (e) {
              if (e.target.getAttribute('href')) return;

              if ($(this).hasClass('open')) {
                $(this).removeClass('open');
                $connectedThirdLevel.slideUp();
              } else {
                $titles.removeClass('open');
                $otherThirdLevels.slideUp();
                $(this).addClass('open');
                $connectedThirdLevel.slideDown();
              }
            });
          });
        });
      }
    });

    const burgerTop = document.getElementById('burger-bar-top');
    const burgerMiddle = document.getElementById('burger-bar-middle');
    const burgerBottom = document.getElementById('burger-bar-bottom');
    var tl = gsap.timeline();

    var isMenuOpen = false;
    $header.find('.header__burger-icon').on('click', function () {
      isMenuOpen = !isMenuOpen;
      $mobileMenu.toggleClass('open');
      $('html').toggleClass('mobile-menu-is-open');

      if (isMenuOpen) {
        $('html').css('overflow-y', 'hidden');
        $header.removeClass('apply-transparency');
        $header.addClass('force-opacity');

        tl = gsap.timeline();
        tl.to(burgerTop, { rotate: 45, duration: 1, y: 7, transformOrigin: 'center', ease: 'elastic.out(1, 0.4)' }, 0);
        tl.to(burgerMiddle, { scaleX: 0, duration: 1, opacity: 0, transformOrigin: 'center', ease: 'elastic.out(1, 0.4)' }, 0);
        tl.to(burgerBottom, { rotate: -45, duration: 1, y: -7, transformOrigin: 'center', ease: 'elastic.out(1, 0.4)' }, 0);
      } else {
        $('html').css('overflow-y', '');
        $header.removeClass('force-opacity');
        if ($(window).scrollTop() === 0) {
          $header.addClass('apply-transparency');
        }

        tl = gsap.timeline();
        tl.to(burgerTop, { rotate: 0, duration: 1, y: 0, transformOrigin: 'center', ease: 'elastic.out(1, 0.4)' }, 0);
        tl.to(burgerMiddle, { scaleX: 1, duration: 1, opacity: 1, transformOrigin: 'center', ease: 'elastic.out(1, 0.4)' }, 0);
        tl.to(burgerBottom, { rotate: 0, duration: 1, y: 0, transformOrigin: 'center', ease: 'elastic.out(1, 0.4)' }, 0);
      }
    });

    const $mobileMenuImages = $('.header__mobile-menu__level__image');
    if ($mobileMenuImages.length > 0) {
      $mobileMenuImages.each(function () {
        const $links = $(this).prev();
        $links.css('height', 'calc(100% - ' + $(this).innerHeight() + 'px - 1rem)');
      });
    }

    $('[data-mobile-menu-opener]').on('click', function (e) {
      if (!e.target.getAttribute('href')) {
        const menuName = $(this).data('mobile-menu-opener');
        $('[data-mobile-menu="' + menuName + '"]').css('transform', 'translate3d(0, 0, 0)');
      }
    });

    $('[data-mobile-menu] .header__mobile-menu__level__title').on('click', function () {
      const $menu = $(this).closest('.header__mobile-menu__level');
      $menu.css('transform', '');
    });

    // Proxy click on menu close
    $('[data-mobile-menu-close]').on('click', () => $('.header__burger-icon').trigger('click'));
  }

  /* ======================== Desktop Menu ======================== */
  const $desktopMenu = $header.find('.header__desktop-menu');
  if ($desktopMenu.length > 0) {
    if ($desktopMenu.hasClass('header__desktop-menu--dropdown')) {
      const $dropdownInlineElements = $desktopMenu.find('.header__desktop-menu--dropdown__inline-elements__link');
      $dropdownInlineElements.each(function () {
        if ($desktopMenu.hasClass('header__desktop-menu--dropdown--alternative') && $(this).find('.header__desktop-menu--dropdown__navigation__element').length <= 0) return;

        $(this).on('mouseenter', function () {
          $(this).find('.header__desktop-menu--dropdown__dropdown-wrapper').addClass('open');
          $header.addClass('force-opacity');
        });

        $(this).on('mouseleave', function () {
          $(this).find('.header__desktop-menu--dropdown__dropdown-wrapper').removeClass('open');
          $header.removeClass('force-opacity');
        });
      });

      if ($desktopMenu.hasClass('header__desktop-menu--dropdown--alternative')) {
        const $sliders = $desktopMenu.find('.header__desktop-menu--dropdown__navigation');
        $sliders.each(function () {
          window.dAgency.initDesktopSlider(this, 2);
        });
      } else {
        $desktopMenu.find('.header__desktop-menu--dropdown__navigation').each(function () {
          const $mediaContainer = $(this).find('.header__desktop-menu--dropdown__navigation__media');
          const $titleWithImages = $(this).find('[data-image-src]');

          $titleWithImages.on('mouseenter', function () {
            const imgSrc = $(this).data('image-src');
            const $img = $mediaContainer.find('[srcset*="' + imgSrc + '"]');

            $mediaContainer.find('.header__desktop-menu--dropdown__navigation__media__img.active').removeClass('active');
            $img.addClass('active');
          });
        });
      }
    } else if ($desktopMenu.hasClass('header__desktop-menu--drawer')) {
      const $firstLevelLinks = $desktopMenu.find('.header__desktop-menu--drawer__inline-elements__link')
      $firstLevelLinks.each(function () {
        $(this).on('mouseenter', function () {
          if ($(window).outerWidth() <= 1024) return;

          $header.addClass('force-opacity');
          $(this).addClass('open');
          $('html').css('overflow-y', 'hidden');
        });

        $(this).on('mouseleave', function () {
          if ($(window).outerWidth() <= 1024) return;

          $header.removeClass('force-opacity');
          $(this).removeClass('open');
          $(this).find('.open').removeClass('open');
          $('html').css('overflow-y', '');
        });
      });

      $desktopMenu.find('.header__desktop-menu--drawer__second-level').each(function () {
        $(this).css('height', 'calc(100vh - ' + headerHeight() + 'px)');

        const $level = $(this);
        $(this).find('.header__desktop-menu--drawer__second-level__title.clickable').on('click', function (e) {
          if (e.target.getAttribute('href')) return;

          const levelIndex = $(this).data('submenu');
          $level.find('.header__desktop-menu--drawer__third-level[data-submenu="' + levelIndex + '"]').addClass('open');
        });
      });

      $(this).find('.header__desktop-menu--drawer__third-level').each(function () {
        const $thirdLevel = $(this);
        const $overflowContainer = $(this).find('.header__desktop-menu--drawer__third-level__overflow-container');
        const $goBack = $(this).find('.header__desktop-menu--drawer__third-level__go-back');

        $overflowContainer.css('height', 'calc(100% - ' + $goBack.outerHeight() + 'px)');
        $goBack.on('click', function () {
          $thirdLevel.removeClass('open');
        });
      });
    }
  }

  /* ==================== Desktop Search PopUp ==================== */
  const $deskSearchBar = $header.find('.header__search-popup');
  if ($deskSearchBar.length > 0) {
    $deskSearchBar.css('top', headerHeight() + 'px');

    const $iconSearch = $header.find('.header__right__element.search');
    if ($iconSearch.length > 0) {
      $iconSearch.on('click', function (e) {
        e.preventDefault();
        $deskSearchBar.toggleClass('open');

        if ($deskSearchBar.hasClass('open')) {
          $header.removeClass('apply-transparency');
          $header.addClass('force-opacity');
          $deskSearchBar.find('form input[type="text"]').trigger('focus');
        } else {
          $header.removeClass('force-opacity');
          if ($(window).scrollTop() === 0) {
            $header.addClass('apply-transparency');
          }
        }
      });
    }

    $(window).on('resize', function () {
      if ($(window).outerWidth() <= 1024) {
        $header.removeClass('force-opacity');
        $deskSearchBar.removeClass('open');

        if ($(window).scrollTop() === 0) {
          $header.addClass('apply-transparency');
        } else {
          $header.removeClass('apply-transparency');
        }
      } else {
        $deskSearchBar.css('top', headerHeight() + 'px');
        $('html').removeClass('mobile-menu-is-open');
      }
    });

    const $closeIcon = $deskSearchBar.find('.header__search-popup__close-icon');
    if ($closeIcon.length > 0) {
      $closeIcon.on('click', function () {
        $deskSearchBar.removeClass('open');
        $header.removeClass('force-opacity');
        if ($(window).scrollTop() === 0) {
          $header.addClass('apply-transparency');
        }
      });
    }
  }
})(jQuery);
